export const emptyScreenTypes = {
  DEFAULT: "default",
  SECONDARY: "secondary",
  SEARCH: "search",
  CHART_AND_TABLE: "chart_and_table",
  CALL_LOGS: "call_logs",
  CALL_QUALITY: "call_quality",
  CALL_CAMPAIGNS: "call_campaigns",
  PROSPECT: "prospect",
};
